import { isApiError, refusalMessageOf } from "@/data/api/client";

/** The API refuses in English and the partner reads Czech, so what it decided
 *  gets a sentence here. A count of uses without a period is the partner's own
 *  mistake — it names the half that is missing rather than reporting a failure
 *  they can do nothing about. */
export function businessSaveRefusalMessage(error: unknown): string | null {
  if (isApiError(error, "DISCOUNT_LIMIT_INCOMPLETE")) {
    return "Počet využití slevy jsme neuložili — vyberte ještě období, za které se využití počítají.";
  }
  if (isApiError(error, "INVALID_EMAIL")) {
    return "E-mail pro potvrzování rezervací musí být platná adresa a nesmí zůstat prázdný — bez něj se k vám rezervace nedostane.";
  }
  return refusalMessageOf(error);
}
